"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateHelper = exports.reducer = exports.initialState = exports.default = void 0;
var _immutable = require("immutable");
var _StateHelper = _interopRequireDefault(require("../../helpers/StateHelper.js"));
var _Quiz = _interopRequireDefault(require("../../factories/Quiz.js"));
var _constants = require("../../constants.js");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = exports.stateHelper = new _StateHelper.default(_Quiz.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
function quizFetchingTake(state) {
  return state.map(function (record) {
    return record.set('notes', new _immutable.Map()).set('highlights', new _immutable.Map()).set('strike_throughs', new _immutable.Map()).set('quiz_blocks', new _immutable.Map()).set('take_fetched_at', null).set('questions_fetched_at', null);
  });
}
function quizFetchedTake(state, payload) {
  var newState = state;
  newState = stateHelper.set(newState, payload).setIn([parseInt(payload.data.id), 'take_fetched_at'], payload.serverTimeNow);
  var question = payload.included.find(function (record) {
    return record.type === 'question';
  });
  if (!question) return newState;
  var questionId = parseInt(question.id);
  if (!questionId) return newState;
  return newState;
}
reducers[_constants.QUIZ_FETCHED_PERFORMANCE] = function (state, payload) {
  return stateHelper.set(state, payload).setIn([parseInt(payload.data.id), 'performance_fetched_at'], payload.serverTimeNow);
};
reducers[_constants.QUIZ_CREATE_SEARCH] = function (state, payload) {
  return state.set(payload.searchId, new _Quiz.default({
    id: payload.searchId,
    attributes: {
      type: 'search',
      name: 'Browse Mode'
    }
  }));
};
reducers[_constants.QUIZ_DELETE_SEARCH] = function (state, payload) {
  return state.delete(payload.searchId);
};
reducers[_constants.QUIZ_ADD_SEARCH_QUESTIONS] = function (state, payload) {
  var updatedQuiz = state.get(payload.searchId).set('question_ids', payload.questionIds);
  return state.set(payload.searchId, updatedQuiz);
};
reducers[_constants.QUIZ_FETCHING_TAKE] = quizFetchingTake;
reducers[_constants.QUIZ_FETCHED_TAKE] = quizFetchedTake;
reducers[_constants.QUIZ_UNLOAD_TAKE] = function (state, payload) {
  var quizId = payload.quizId;
  var newQuiz = state.get(quizId).set('take_fetched_at', null).set('questions_fetched_at', null).set('time_slices', (0, _immutable.List)()).set('seen_questions', (0, _immutable.Map)()).set('notes', (0, _immutable.Map)()).set('highlights', (0, _immutable.Map)()).set('strike_throughs', (0, _immutable.Map)()).set('quiz_blocks', (0, _immutable.Map)());
  return state.set(quizId, newQuiz);
};
reducers[_constants.QUIZ_FETCHED_PRACTICE] = stateHelper.set;
reducers[_constants.QUIZ_END_QUIZ_BLOCK_SYNCED] = stateHelper.set;
reducers[_constants.QUIZ_FETCHED_ALL_QUESTIONS] = function (state, payload) {
  return state.setIn([payload.quizId, 'questions_fetched_at'], payload.serverTimeNow);
};
reducers[_constants.QUIZZES_FETCHED] = stateHelper.set;
reducers[_constants.QUIZ_CREATING] = quizFetchingTake;
reducers[_constants.QUIZ_CREATED] = quizFetchedTake;
reducers[_constants.QUIZ_SEEN_QUESTION_SYNCED] = stateHelper.set;
reducers[_constants.QUIZ_SEEN_QUESTION_OFFLINE] = function quizSeenQuestionOffline(state, payload) {
  var newState = state.setIn([payload.quizId, 'seen_questions', payload.questionId], payload.lastSeenAt).setIn([payload.quizId, 'last_seen_question_number'], payload.questionNumber).setIn([payload.quizId, 'synced'], false).setIn([payload.quizId, 'updated_at'], payload.serverTimeNow);
  if (!payload.groupId) return newState;
  return newState.updateIn([payload.quizId, 'seen_case_question_ids'], function (questionIds) {
    return questionIds.push(payload.questionId);
  });
};
reducers[_constants.QUIZ_TICK] = function quizTick(state, payload) {
  // If we dispatch a 0-second Quiz Tick then we need to change the state without changing any values.
  // This is used by No-Pause and Due-Date Assignments.
  if (payload.seconds === 0) {
    return state.set('cache-buster', true).delete('cache-buster');
  }
  var newSecondsRemaining = 0;
  var quiz = state.get(payload.quizId);
  var newState = state;
  if (!quiz) {
    return newState;
  }
  var whichSeconds = 'seconds_remaining';
  if (quiz.get('quiz_blocks') !== undefined && quiz.get('quiz_blocks').size) {
    var currentBlock = quiz.get('quiz_blocks').find(function (b) {
      return b.get('position') === quiz.get('last_quiz_block_number');
    });
    if (!!currentBlock && currentBlock.get('question_ids') && currentBlock.get('question_ids').size) {
      if (quiz.get('block_pool_seconds_remaining') !== null) {
        if (quiz.get('block_pool_seconds_remaining') === 0) {
          newSecondsRemaining = 0;
        } else {
          newSecondsRemaining = quiz.get('block_pool_seconds_remaining') - payload.seconds;
        }
        whichSeconds = 'block_pool_seconds_remaining';
      }
    } else if (quiz.get('break_pool_seconds_remaining') !== null) {
      if (quiz.get('break_pool_seconds_remaining') === 0) {
        newSecondsRemaining = 0;
      } else {
        newSecondsRemaining = quiz.get('break_pool_seconds_remaining') - payload.seconds;
      }
      whichSeconds = 'break_pool_seconds_remaining';
    }
  } else {
    newSecondsRemaining = quiz.get('seconds_remaining') - payload.seconds;
    if (newSecondsRemaining <= 0) {
      newState = newState.setIn([payload.quizId, 'status'], "ready-for-submission");
    }
  }
  return newState.setIn([payload.quizId, whichSeconds], newSecondsRemaining).setIn([payload.quizId, 'synced'], false).setIn([payload.quizId, 'updated_at'], payload.serverTimeNow);
};
reducers[_constants.QUIZ_TICK_SYNCED] = function (state, payload) {
  return stateHelper.set(state, payload);
};
reducers[_constants.QUIZ_SUBMITTED] = function (state, payload) {
  return stateHelper.set(state, payload).setIn([parseInt(payload.data.id), 'performance_fetched_at'], payload.serverTimeNow);
};
reducers[_constants.QUIZ_ARCHIVED] = stateHelper.set;
reducers[_constants.QUIZ_UNARCHIVED] = stateHelper.set;
reducers[_constants.QUIZZES_ARCHIVED] = stateHelper.update;
reducers[_constants.QUIZZES_UNARCHIVED] = stateHelper.update;

// Non-Quizzes Action Reducers

reducers[_constants.QUIZ_QUESTION_FETCHED_NEXT] = stateHelper.set;
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.QUIZ_UNLOAD_PERFORMANCE] = stateHelper.reset;
reducers[_constants.OFFLINE_QUIZ_SYNCED] = stateHelper.update;
reducers[_constants.OFFLINE_QUIZ_LOADED] = function offlineQuizLoaded(state, payload) {
  var newState = quizFetchingTake(state, _objectSpread({
    key: 'offline-load'
  }, payload));
  payload.questions.forEach(function (question) {
    var key = "".concat(payload.quiz.get('id'), "/questions/").concat(question.get('id'));
    newState = newState.setIn(['fetched_ats', key], payload.quiz.get('questions_fetched_at'));
  });

  // Left instance of new Date getTime here b/c not sure if server time was available
  return newState.set(payload.quiz.get('id'), payload.quiz).setIn([payload.quiz.get('id'), 'take_fetched_at'], new Date().getTime());
};
reducers[_constants.QUIZ_SET_LAST_SEEN_BLOCK] = function quizSetLastSeenBlock(state, payload) {
  return state.setIn([payload.quizId, 'last_quiz_block_number'], payload.position);
};
reducers[_constants.RESPONSE_SYNC_OFFLINE] = function responseSyncOffline(state, payload) {
  var createdAt = payload.createdAt,
    quizId = payload.quizId,
    questionId = payload.questionId,
    event = payload.event,
    time = payload.time;
  var newTimeSlice = (0, _immutable.Map)({
    created_at: createdAt,
    question_id: questionId,
    event: event,
    time: time
  });
  var newQuiz = state.get(quizId);
  newQuiz = newQuiz.update('time_slices', function (timeSlices) {
    return timeSlices.push(newTimeSlice);
  });
  newQuiz = newQuiz.set('synced', false);
  return state.set(payload.quizId, newQuiz);
};
reducers[_constants.PERFORMANCE_QUIZZES_FETCHED] = function performanceQuizzesFetched(state, payload) {
  return state.withMutations(function (newState) {
    payload.quizzes.forEach(function (quiz) {
      newState.set(quiz[0], new _immutable.Map({
        id: quiz[0],
        question_bank_id: quiz[1],
        status: quiz[2],
        type: quiz[3],
        archived: quiz[4],
        total_questions: quiz[5],
        assignment_id: quiz[6] || 0,
        name: quiz[7],
        created_at: Math.floor(quiz[8] * 1000),
        seconds_per_question: quiz[9],
        seconds_remaining: quiz[10],
        updated_at: Math.floor(quiz[11] * 1000),
        started_at: Math.floor(quiz[12] * 1000),
        end_time: Math.floor(quiz[13] * 1000),
        offline_device_uuid: quiz[14],
        last_seen_question_number: quiz[15],
        percentile: quiz[16],
        difficulty_level: quiz[17],
        practice_exam_template_id: quiz[18],
        is_ngn: quiz[19],
        cutoff_time: quiz[20],
        question_ids: JSON.parse("[" + quiz[21].slice(1, quiz[21].length - 1) + "]"),
        user_id: quiz[22]
      }));
    });
  });
};
reducers[_constants.ASSIGNMENT_QUIZZES_FETCHED] = function assignmentQuizzesPerformance(state, payload) {
  return state.withMutations(function (newState) {
    payload.list.forEach(function (assignmentQuizzes) {
      // parsing question_ids to array
      var ids = [];
      var id = '';
      for (var i = 0; i < assignmentQuizzes.question_ids.length; i += 1) {
        var char = assignmentQuizzes.question_ids[i];
        if (char !== '{' && char !== '}' && char !== ',') {
          id += char;
        } else if (char === ',' || char === '}') {
          ids.push(parseInt(id));
          id = '';
        }
      }
      var quizObject = {
        id: assignmentQuizzes.id,
        attributes: {
          status: assignmentQuizzes.status,
          end_time: Math.floor(parseInt(assignmentQuizzes.end_time) * 1000),
          total_questions: assignmentQuizzes.total_questions,
          question_ids: ids,
          potential_score: assignmentQuizzes.potential_score,
          actual_score: assignmentQuizzes.actual_score,
          is_ngn: assignmentQuizzes.is_ngn,
          num_answered_correctly: assignmentQuizzes.cached_num_answered_correctly,
          num_answered: assignmentQuizzes.cached_num_answered,
          score: assignmentQuizzes.score,
          percentile: assignmentQuizzes.percentile,
          difficulty_level: assignmentQuizzes.difficulty_level
        },
        relationships: {
          user: {
            data: {
              id: assignmentQuizzes.user_id
            }
          },
          assignment: {
            data: {
              id: assignmentQuizzes.assignment_id
            }
          },
          question_bank: {
            data: {
              id: assignmentQuizzes.question_bank_id
            }
          }
        }
      };
      if (newState.has(assignmentQuizzes.id)) {
        newState.update(assignmentQuizzes.id, function (quiz) {
          return quiz.merge(quizObject);
        });
      } else {
        newState.set(assignmentQuizzes.id, new _Quiz.default(quizObject));
      }
    });
  });
};
var reducer = exports.reducer = stateHelper.createReducer(reducers);
var _default = exports.default = reducers;